import { render } from "./MDText.vue?vue&type=template&id=1c7b1739&scoped=true"
import script from "./MDText.vue?vue&type=script&lang=js"
export * from "./MDText.vue?vue&type=script&lang=js"

import "./MDText.vue?vue&type=style&index=0&id=1c7b1739&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7b1739"]])

export default __exports__